import React from 'react'

import { Typography, MediaImageStandard } from 'components/Contentful'
import { Button, Grid, Box, AchieveTheme } from '@achieve/ascend'
import { useMemoizedContentGetter } from 'utils/contentful'
import Section from 'components/Section'
import SlideOnVisible from 'components/SlideOnVisible'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import styles from './StoryBlocks.module.scss'
import { Eyebrow } from 'components/Eyebrow'
import {
  SLIDE_ON_VISIBLE_EASING_DEFAULT,
  SLIDE_ON_VISIBLE_DURATION_DEFAULT,
} from 'constants/animation'
import classNames from 'classnames'

const StoryBlocks = ({ content }) => {
  const { eyebrow, title, storyBlockGrid } = useMemoizedContentGetter(content, [
    'eyebrow',
    'title',
    'storyBlockGrid',
  ])

  return (
    <Section
      backgroundColor={AchieveTheme?.ascend?.colors?.neutral?.[0]}
      data-testid="story-blocks-section"
      contain={false}
      className={eyebrow || title ? styles['story-blocks-container'] : ''}
    >
      {(eyebrow || title) && (
        <Grid container justifyContent="center">
          <Grid
            size={{ xxs: 6, xs: 11, sm: 10, md: 10, lg: 10, xl: 8 }}
            className="xl:basis-1/2  lg:basis-8/12 md:basis-10/12 sm:basis-10/12 "
            justifyContent="space-around"
            data-testid="mediabox-title"
          >
            <Eyebrow
              data-testid="story-block-eyebrow"
              content={eyebrow?.textContent}
              variant="bodySm"
              fontWeight="bold"
              component="h3"
            />
            <Typography
              data-testid="member-stories-story-block-title"
              className={classNames(styles['title'], 'displayMd lg:displayLg font-bold!')}
              content={title?.textContent}
              fontWeight="bold"
              component="h2"
            />
          </Grid>
        </Grid>
      )}
      <Grid container direction="row" justifyContent="space-evenly" data-testid="media-box-grid">
        {storyBlockGrid &&
          storyBlockGrid?.gridItemsCollection?.items?.map((card, index) => {
            return (
              <React.Fragment key={card?.sys?.id}>
                <Grid
                  size={{ xs: 12, md: 6 }}
                  sx={{ order: { xs: index + 1, md: index % 2 ? index + 2 : index + 1 } }}
                  className="md:basis-1/2"
                >
                  <div className={styles['block-img']}>
                    <MediaImageStandard
                      data-testid={`block-img-${index}`}
                      content={card.image}
                      alt={card.altText}
                      layout="fill"
                      objectFit="cover"
                    />
                  </div>
                </Grid>
                <Grid
                  size={{ xs: 12, md: 6 }}
                  sx={{ order: { xs: index + 2, md: index % 2 ? index : index + 1 } }}
                  className={classNames(styles['content-box'], 'md:basis-1/2')}
                  data-testid={`content-box-item-${index}`}
                >
                  <Box
                    className={classNames(styles['box-media-text'], 'md:basis-1/2')}
                    data-testid={`story-block-box-${index}`}
                  >
                    <SlideOnVisible
                      scrollOnMobile={false}
                      duration={SLIDE_ON_VISIBLE_DURATION_DEFAULT}
                      timeout={0}
                      easing={SLIDE_ON_VISIBLE_EASING_DEFAULT}
                    >
                      <div className={styles['text-center']}>
                        <Typography
                          data-testid={`story-block-title-${index}`}
                          fontWeight="bold"
                          variant="displayMd"
                          style={{ marginBottom: '24px' }}
                          content={card.title}
                        />
                        <Typography
                          data-testid={`story-block-text-${index}`}
                          style={{ marginBottom: '24px', justifyContent: 'space-between' }}
                          variant="bodySm"
                          content={card.text}
                        />
                        {card.link?.linkHref ? (
                          <div className={styles['button-wrapper']}>
                            <Button
                              data-testid={`story-block-button-${index}`}
                              href={card.link.linkHref}
                              className={styles['link-button']}
                              endIcon={<ArrowForwardIcon />}
                            >
                              <Typography
                                content={card.link.linkText?.json}
                                fontWeight="bold"
                                className="bodySm lg:bodyLg"
                              />
                            </Button>
                          </div>
                        ) : null}
                      </div>
                    </SlideOnVisible>
                  </Box>
                </Grid>
              </React.Fragment>
            )
          })}
      </Grid>
    </Section>
  )
}
export { StoryBlocks }
export default StoryBlocks
